import React from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import TagManager from "react-gtm-module";

import {
  signin_path,
  accountdetail_path,
  campaignedit_path,
  adgroups_path,
  adgroupedit_path,
  advertisements_path,
  advertisementedit_path,
  crassets_path,
  crassetedit_path,
  crassetcsvuploadms_path,
  csvupload_path,
  accountdetailms_path,
  campaigneditms_path,
  adgroupsms_path,
  adgroupeditms_path,
  advertisementsms_path,
  advertisementeditms_path,
  crassetsms_path,
  crasseteditms_path,
  manuals_path,
  home_path,
  isummary_path,
  review_csv_path,
  review_csv_request_path,
  invoice_path,
  adclienticonsapproval_path,
  trackerIdMigration,
} from "./components/atom/Apollo_links";
import ScrollToTop from "./ScrollToTop";

import CrAssetEditImage from "./components/pages/CRASSET/zeus/CrAssetEditImage";
import AdvertisementEditZeus from "./components/pages/ADVERTISEMENT/zeus/AdvertisementEditZeus";
import AdGroupEditZeus from "./components/pages/ADGROUP/zeus/AdGroupEditZeus";
import CampaignEditZeus from "./components/pages/CAMPAIGN/zeus/CampaignEditZeus";

import UserDetail from "./components/pages/USER/UserDetail";
import UserEdit from "./components/pages/USER/UserEdit";
import UserPage from "./components/pages/USER/UserPage";

import AccountGroupDetail from "./components/pages/ACCOUNT/AccountGroupDetail";
import AccountGroupPage from "./components/pages/ACCOUNT/AccountGroupPage";
import Apollo_UnapprovedAccountList from "./components/organism/ACCOUNT/Apollo_UnapprovedAccountList";
import AccountDetailZeus from "./components/pages/ACCOUNT/zeus/AccountDetailZeus";
import AccountDetailApollo from "./components/pages/ACCOUNT/AccountDetailApollo";
import AccountGroupEdit from "./components/pages/ACCOUNT/AccountGroupEdit";
import AccountEditApollo from "./components/pages/ACCOUNT/AccountEditApollo";
import AdClientIconPageApollo from "./components/pages/ACCOUNT/AdClientIconPageApollo";
import AdClientIconCreateApollo from "./components/pages/ACCOUNT/AdClientIconCreateApollo";
import AdClientIconApprovalPage from "./components/pages/ACCOUNT/AdClientIconApprovalPage";

import InVoice from "./components/pages/INVOICE/InVoicePage";
import ReportPage from "./components/pages/REPORT/ReportPage";
import ReportCreate from "./components/pages/REPORT/ReportCreate";
import ReportDetail from "./components/pages/REPORT/ReportDetail";
import PastReportPage from "./components/pages/PASTREPORT/PastReportPage";
// マスター管理
import MasterProducts from "./components/pages/MASTER/MasterProducts";
import MasterIndustorys from "./components/pages/MASTER/MasterIndustorys";
import MasterBillingResources from "./components/pages/MASTER/MasterBillingResources";

import HeraEventsPage from "./components/pages/HERA/HeraEventsPage";
import HeraAudiencesPage from "./components/pages/HERA/HeraAudiencesPage";
import HeraAudienceDetail from "./components/pages/HERA/HeraAudienceDetail";
import HeraAudienceEdit from "./components/pages/HERA/HeraAudienceEdit";

import HeraSetPointsPage from "./components/pages/HERA/HeraSetPointsPage";
import HeraSetPointDetail from "./components/pages/HERA/HeraSetPointDetail";
import HeraSetPointEdit from "./components/pages/HERA/HeraSetPointEdit";

import ApolloContextProvider from "./components/atom/Apollo_Context";
import ApolloSignIn from "./components/pages/SIGNIN/SignIn";

import {ApolloMessageProvider} from "./components/atom/Apollo_Mesasge";
import NotifyPage from "./components/pages/NOTIFY/NotifyPage";
import NotifyDetail from "./components/pages/NOTIFY/NotifyDetail";
import NotifyEdit from "./components/pages/NOTIFY/NotifyEdit";
import SegmentDetail from "./components/pages/SEGMENT/poseidon/SegmentDetail";
import AffinityCategoryTop from "./components/pages/SEGMENT/poseidon/AffinityCategoryTop";
import AffinityCategoryEdit from "./components/pages/SEGMENT/poseidon/AffinityCategoryEdit";
import CustomSegmentTop from "./components/pages/ADACCOUNT/poseidon/CustomSegmentTop";
import GeoSegmentTop from "./components/pages/ADACCOUNT/poseidon/GeoSegmentTop";
import UserListTop from "./components/pages/ADACCOUNT/poseidon/UserListTop";
import UserListEdit from "./components/pages/ADACCOUNT/poseidon/UserListEdit";

import {ApolloRightDrawerProvider} from "./components/molecule/Apollo_RightDrawer";

// 予算管理
import BudgetPage from "./components/pages/BUDGET/BudgetPage";
import BudgetDetail from "./components/pages/BUDGET/BudgetDetail";
import AccountDetailMs from "./components/pages/ACCOUNT/ms/AccountDetailMs";
import CampaignCreateMs from "./components/pages/CAMPAIGN/ms/CampaignCreateMs";
import AdAssetsCreate from "./components/pages/CRASSET/ms/AdAssetCreate";
import AdAssetsList from "./components/pages/CRASSET/ms/AdAssetsList";
import AdAssetCsvUploadMs from "./components/pages/CRASSET/ms/AdAssetCsvUploadMs";
import AdvertisementsCreateMs from "./components/pages/ADVERTISEMENT/ms/AdvertisementsCreateMs";
import AdGroupCreateMs from "./components/pages/ADGROUP/ms/AdGroupCreateMs";
import OperationCSVUploadZeus from "./components/pages/OPERATION/zeus/OperationCSVUploadZeus";
import OperationCSVUploadMs from "./components/pages/OPERATION/ms/OperationCSVUploadMs";
import OperationHistoryList from "./components/pages/HISTORY/OperationHistoryList";
import CrAssetCreateImageZeus from "./components/pages/CRASSET/zeus/CrAssetEditImage";
import TagsAssetCreateImageZeus from "./components/pages/CRASSET/zeus/TagsAssetEdit";
import CrAssetsPageZeus from "./components/pages/CRASSET/zeus/CrAssetsPage";
import CampaignCreateZeus from "./components/pages/CAMPAIGN/zeus/CampaignCreateZeus";
import AdGroupCreateZeus from "./components/pages/ADGROUP/zeus/AdGroupCreateZeus";
import AdvertisementCreateZeus from "./components/pages/ADVERTISEMENT/zeus/AdvertisementCreateZeus";
import ManualPage from "./components/pages/MANUAL/ManualPage";
import ReviewCsvPageZeus from "./components/pages/REVIEWCSV/zeus/ReviewCsvPage";
import ReviewCsvRequestZeus from "./components/pages/REVIEWCSV/zeus/ReviewCsvRequest";

// トラッカーID移行
import TrackerIdMigration from "./components/pages/TRACKERID/TrackerIdMigration";

import AccountSummary from "./components/pages/SUMMARY/AccountSummary";
import Isummary from "./components/pages/SUMMARY/IndividualSummary"
import AdGroupPageZeus from "./components/pages/ADGROUP/zeus/AdGroupPageZeus";
import AdvertisementPageZeus from "./components/pages/ADVERTISEMENT/zeus/AdvertisementPageZeus";
import AdGroupListMs from "./components/pages/ADGROUP/ms/AdGroupListMs";
import AdvertisementsListMs from "./components/pages/ADVERTISEMENT/ms/AdvertisementsListMs";

const App: React.FC = () => {
  React.useEffect(() => {
    TagManager.initialize({gtmId: process.env.REACT_APP_GTM_ID ?? ""});
  }, []);

  return (
    <ApolloContextProvider>
      <ApolloMessageProvider>
        <ApolloRightDrawerProvider>
          <Router>
            <ScrollToTop/>
            <Switch>
              <Route path="/" component={ApolloSignIn} exact/>
              <Route path={signin_path} component={ApolloSignIn} exact/>

              <Route path="/users" component={UserPage} exact/>
              <Route path="/userdetail/:userid" component={UserDetail} exact/>
              <Route path="/useredit/:userid" component={UserEdit} exact/>

              <Route path="/info" component={NotifyPage} exact/>
              <Route path="/infodetail/:infoid" component={NotifyDetail} exact/>
              <Route path="/infoedit/:infoid" component={NotifyEdit} exact/>

              // 確定請求金額管理
              <Route path={invoice_path} component={InVoice} exact/>
              <Route path="/reports" component={ReportPage} exact/>
              <Route path="/Reportcreate" component={ReportCreate} exact/>
              <Route path="/Reportdetail/:reportSettingId" component={ReportDetail} exact/>
              <Route path="/pastreport" component={PastReportPage} exact/>

              // マスター管理
              <Route path="/masterproducts" component={MasterProducts} exact/>
              <Route path="/masterindustorys" component={MasterIndustorys} exact/>
              <Route path="/masterbillingresources" component={MasterBillingResources} exact/>

              // マニュアル管理
              <Route path={manuals_path} component={ManualPage} exact/>

              <Route path="/accountgroups" component={AccountGroupPage} exact/>
              <Route path="/unapprovedaccounts" component={Apollo_UnapprovedAccountList} exact/>
              <Route path="/accountgroupdetail/:accountgroupid" component={AccountGroupDetail} exact/>
              <Route path="/accountgroupedit/:accountgroupid" component={AccountGroupEdit} exact/>

              <Route path="/accounteditapollo/:accountgroupid/:accountid" component={AccountEditApollo} exact/>
              <Route path="/accountdetailapollo/:accountgroupid/:accountid" component={AccountDetailApollo} exact/>
              <Route path="/adclienticonsapollo/:accountgroupid/:accountid" component={AdClientIconPageApollo} exact/>
              <Route path="/adclienticoneditapollo/:accountgroupid/:accountid" component={AdClientIconCreateApollo} exact/>
              <Route path={adclienticonsapproval_path} component={AdClientIconApprovalPage} exact/>

              <Route path="/hera/events" component={HeraEventsPage} exact/>
              <Route path="/hera/audiences" component={HeraAudiencesPage} exact/>
              <Route path="/hera/audience/detail/:audienceId" component={HeraAudienceDetail} exact/>
              <Route path="/hera/audience/edit/:audienceId" component={HeraAudienceEdit} exact/>

              <Route path="/hera/setpoints" component={HeraSetPointsPage} exact/>
              <Route path="/hera/setpoint/detail/:setPointId" component={HeraSetPointDetail} exact/>
              <Route path="/hera/setpoint/edit/:setPointId" component={HeraSetPointEdit} exact/>

              <Route path="/segmentdetail/poseidon/:segmentId" component={SegmentDetail} exact/>
              <Route path="/affinitycategory/poseidon" component={AffinityCategoryTop} exact/>
              <Route path="/affinitycategoryedit/poseidon/:affinityCategoryId" component={AffinityCategoryEdit} exact/>
              <Route path="/affinitycategoryedit/poseidon/:affinityCategoryId/:copyAffinityCategoryId"
                     component={AffinityCategoryEdit} exact/>
              <Route path="/customsegment/poseidon" component={CustomSegmentTop} exact/>
              <Route path="/geosegment/poseidon" component={GeoSegmentTop} exact/>
              <Route path="/userlist/poseidon" component={UserListTop} exact/>
              <Route path="/userlistedit/poseidon/:userListId" component={UserListEdit} exact/>
              <Route path="/userlistedit/poseidon/:userListId/:copyUserListId" component={UserListEdit} exact/>

              // 予算管理
              <Route path="/budgets" component={BudgetPage} exact/>
              <Route path="/budgets/:yearMonth" component={BudgetPage} exact/>
              <Route path="/budget/:accountid/:yearMonth" component={BudgetDetail} exact/>

              // トラッカーID移行
              <Route path={trackerIdMigration} component={TrackerIdMigration} exact/>

              {/* Zeus関連画面 */}
              <Route path={accountdetail_path + "/zeus/:accountgroupid/:accountid/:platformaccountid"}
                     component={AccountDetailZeus} exact/>

              <Route path={campaignedit_path + "zeus/:accountgroupId/:accountid/:zeusaccountid/:zeuscampaignid"}
                     component={CampaignEditZeus} exact/>
              <Route path={adgroupedit_path + "zeus/:accountgroupid/:accountid/:zeusaccountid/:zeuscampaignid/:adGroupId"}
                     component={AdGroupEditZeus} exact/>
              <Route
                path={advertisementedit_path + "zeus/:accountgroupid/:accountid/:zeusaccountid/:zeuscampaignid/:adgroupid/:adid"}
                component={AdvertisementEditZeus} exact/>
              <Route path={crassetedit_path + "zeus/image/:accountgroupid/:accountid/:zeusaccountid/:crassetid"}
                     component={CrAssetEditImage} exact/>

              <Route path={campaignedit_path + "zeus/:accountgroupid/:accountid/:platformaccountid"}
                     component={CampaignCreateZeus} exact/>
              <Route path={adgroupedit_path + "zeus/:accountgroupid/:accountid/:platformaccountid"}
                     component={AdGroupCreateZeus} exact/>
              <Route path={advertisementedit_path + "zeus/:accountgroupid/:accountid/:platformaccountid"}
                     component={AdvertisementCreateZeus} exact/>
              <Route path={crassets_path + "zeus/:accountgroupid/:accountid/:platformaccountid"} component={CrAssetsPageZeus}
                     exact/>
              <Route path={crassetedit_path + "zeus/image/:accountgroupid/:accountid/:platformaccountid"}
                     component={CrAssetCreateImageZeus} exact/>
              <Route path={csvupload_path + "zeus/:accountgroupid/:accountid/:platformaccountid"}
                     component={OperationCSVUploadZeus} exact/>
              <Route path={crassetedit_path + "zeus/tags/:accountgroupid/:accountid/:platformaccountid"}
                     component={TagsAssetCreateImageZeus} exact/>
              <Route path={review_csv_path + "zeus/:accountgroupid/:accountid/:platformaccountid"}
                     component={ReviewCsvPageZeus} exact/>
              <Route path={review_csv_request_path + "zeus/:accountgroupid/:accountid/:platformaccountid"}
                     component={ReviewCsvRequestZeus} exact/>


              {/* MS関連画面 */}
              <Route path={accountdetailms_path + ":accountgroupid/:accountid/:platformaccountid"}
                     component={AccountDetailMs} exact/>
              <Route path={campaigneditms_path + ":accountgroupid/:accountid/:platformaccountid"}
                     component={CampaignCreateMs} exact/>
              <Route path={adgroupeditms_path + ":accountgroupid/:accountid/:platformaccountid"}
                     component={AdGroupCreateMs} exact/>
              <Route path={advertisementeditms_path + ":accountgroupid/:accountid/:platformaccountid"}
                     component={AdvertisementsCreateMs} exact/>
              <Route path={csvupload_path + "ms/:accountgroupid/:accountid/:platformaccountid"}
                     component={OperationCSVUploadMs} exact/>
              <Route path={crassetsms_path + ":accountgroupid/:accountid/:platformaccountid"} component={AdAssetsList}
                     exact/>
              <Route path={crasseteditms_path + ":accountgroupid/:accountid/:platformaccountid"}
                     component={AdAssetsCreate} exact/>
              <Route path={crassetcsvuploadms_path + ":accountgroupid/:accountid/:platformaccountid"}
                     component={AdAssetCsvUploadMs} exact/>

              <Route path="/history" component={OperationHistoryList} exact/>

              <Route path={home_path} component={AccountSummary} exact/>
              <Route path={isummary_path} component={Isummary} exact/>
              <Route path={adgroups_path + "zeus/:accountgroupid/:accountid/:platformaccountid"} component={AdGroupPageZeus} exact/>
              <Route path={advertisements_path + "zeus/:accountgroupid/:accountid/:platformaccountid"} component={AdvertisementPageZeus} exact/>
              <Route path={adgroupsms_path + ":accountgroupid/:accountid/:platformaccountid"} component={AdGroupListMs} exact/>
              <Route path={advertisementsms_path + ":accountgroupid/:accountid/:platformaccountid"} component={AdvertisementsListMs} exact/>
            </Switch>
          </Router>
        </ApolloRightDrawerProvider>
      </ApolloMessageProvider>
    </ApolloContextProvider>
  );
};

export default App;
